import { LoadAddress } from 'domain/usecases/address/load-address'
import { AddressRepository } from 'repository/interfaces/address-repository'

export class RemoteLoadAddress implements LoadAddress {
  private readonly addressRepository: AddressRepository

  constructor(addressRepository: AddressRepository) {
    this.addressRepository = addressRepository
  }

  load(): Promise<LoadAddress.Model> {
    return this.addressRepository.loadAddress()
  }
}
